import React, { useContext, useEffect } from "react";
import AppContext from "../../../Context/AppContext";
import { KTSVG, toAbsoluteUrl } from "../../../helpers";
import requestAxios from "../../../util/requestAxios";
import "./GestorInfo.css";
const GestorInfo = () => {
  const { checkUserSession } = useContext(AppContext);
  const infoUs = checkUserSession();
  useEffect(() => {
    loadInfo();
  }, []);

  async function loadInfo() {
    const { error, data } = await requestAxios({
      url: `Acreditados/getRegistrosMes`,
      method: "get",
      // token: infoUs.bearer_token,
      data: {},
    });

    // setListItem(newObj);
    // setInfoModel(data);
  }
  return (
    <div className="GestorInfo_container">
      <div className="GestorInfo_Imgcontainer">
        <KTSVG path={"/img/Icons/defaultUser.svg"} className={`svg-icon`} />
      </div>
      <div className="GestorInfo_InfoContainer">
        <div className="GestorInfo_Name">({infoUs.CarGclave}){infoUs.GesRazonSocial} <KTSVG path={"/img/Icons/checkblue.svg"} className={`svg-icon-primary svg-icon `} /></div>
        <div className="GestorInfo_Fields">
          <div className="GestorInfo_GestorType">
            <KTSVG path={"/img/Icons/defaultUser.svg"} className={`svg-icon`} />
            Gestor
          </div>
          <div className="GestorInfo_Ciudad">
            <KTSVG path={"/img/Icons/Maps.svg"} className={`svg-icon`} />
            Hermosillo
          </div>
          <div className="GestorInfo_Email">
            <KTSVG path={"/img/Icons/Email.svg"} className={`svg-icon`} />
            {infoUs.GesEmail}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GestorInfo;
